"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";

import {
  createRendererApiClient,
  resolvePublicPrefix,
  type RendererApiClient,
} from "../../utils/rendererApi";

const RendererApiContext = createContext<RendererApiClient | null>(null);

const defaultRendererApiClient = createRendererApiClient({ prefix: "" });

export const RendererApiProvider = ({
  requestPath,
  browserPath,
  children,
}: {
  requestPath: string | null;
  browserPath: string;
  children: ReactNode;
}) => {
  const client = useMemo(
    () => createRendererApiClient({ prefix: resolvePublicPrefix({ browserPath, requestPath }) }),
    [browserPath, requestPath],
  );

  return <RendererApiContext.Provider value={client}>{children}</RendererApiContext.Provider>;
};

export const useRendererApi = (): RendererApiClient =>
  useContext(RendererApiContext) ?? defaultRendererApiClient;
